export const normalizeMarkdown=text=>{return text.replace(/\n/g,'\n\n');};